var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.777 8.558-1.79.894-2.223-4.45L7.988.556l1.788.895-1.378 2.756L8.52 4c4.243 0 7.68 3.58 7.68 8 0 1.57-.441 3.03-1.19 4.26l-1.402-1.46c.432-.83.672-1.79.672-2.8 0-3.31-2.582-6-5.76-6l-.13-.22 1.387 2.778ZM8.52 18c-3.178 0-5.76-2.69-5.76-6 0-1.01.24-1.97.672-2.8L2.03 7.74A8.174 8.174 0 0 0 .84 12c0 4.405 3.414 7.976 7.637 8l-1.254 2.507 1.789.895 2.223-4.444-2.223-4.45-1.79.893 1.3 2.6L8.52 18Z",
    fill: "#1B1D1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResync);
export default __webpack_public_path__ + "static/media/resync.13d88069.svg";
export { ForwardRef as ReactComponent };